import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";

addToChainAfter(chain, PopulateApiParameter, ({ apiParameter }) => {
    apiParameter.additionalExpands = ["properties"];
});
